exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 1024px) {\n.main-tabs[data-v-ca4bc2ba] {\n    display: none !important;\n}\n}", ""]);

// exports
